module.exports = __webpack_public_path__ + "img/about-img.59e7e8e1.jpg";